import script from "./AdminAppSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAppSelect.vue?vue&type=script&setup=true&lang=js"

import "./AdminAppSelect.vue?vue&type=style&index=0&id=0463030c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0463030c"]])

export default __exports__